import { chinaInapi } from '@/apis/chinaInapi';

export default () => ({
  // 欢迎语(팔로우 환영 메시지) 관리 — china-inapi 테넌트 스코프 API (SPEC-CHINA-GZH-AUTOREPLY-TENANT-001 M3, AC-FE-SWITCH-001)
  welcomeMessage: {
    // 소유 공중계정 목록 조회 (AC-TENANT-001) — { owned: [{ gzhName, displayName, accountType }] }
    getOwned: () => {
      return chinaInapi.get('/cn/wechat/gzh/owned');
    },

    // 선택된 공중계정의 欢迎语 조회 (AC-TENANT-002/AC-AUTOREPLY-001)
    getWelcome: (name) => {
      return chinaInapi.get('/cn/wechat/gzh/welcome', { params: { name } });
    },

    // 선택된 공중계정의 欢迎语 저장 (AC-AUTOREPLY-002/AC-AUTOREPLY-005)
    updateWelcome: (name, gzhFollowAutoReplay) => {
      return chinaInapi.put('/cn/wechat/gzh/welcome', { gzhFollowAutoReplay }, { params: { name } });
    }
  },

  // 小程序 링크 삽입 도구 — 신규 엔드포인트가 아니라 CustomizeMenu.vue(小程序 피커/페이지 카탈로그)가
  // 이미 사용 중인 chinaInapi 엔드포인트를 그대로 재사용한다(SPEC-CHINA-GZH-MINIAPP-PICKER-001 wxamplinkget 기반,
  // SPEC-CHINA-GZH-MINIAPP-PAGES-001 페이지 카탈로그). 欢迎语 탭에서 gzhName-스코프로 호출한다.
  miniprogram: {
    // 공중계정에 关联(연결)된 미니앱 목록
    getList: (gzhName) => {
      return chinaInapi.get(`/wechat-gzh-menu/${gzhName}/miniprograms`);
    },
    // 선택된 미니앱의 페이지 카탈로그
    getPages: (gzhName, appid) => {
      return chinaInapi.get(`/wechat-gzh-menu/${gzhName}/miniapp-pages?appid=${encodeURIComponent(appid)}`);
    }
  },

  // [공중계정 연동 관리] 테넌트 셀프서브 온보딩 API (china-inapi wechat-gzh-accounts)
  // 비밀값은 쓰기 전용 — 목록 응답은 appSecretMasked/hasToken/hasEncodingAesKey만 온다.
  gzhAccounts: {
    // 소유 공중계정 설정 목록 — { accounts: [{ gzhName, displayName, accountType, configComplete, appId, gzhUserId, appSecretMasked, hasToken, hasEncodingAesKey }] }
    getList: () => {
      return chinaInapi.get('/wechat-gzh-accounts');
    },

    // 신규 공중계정 등록 (호출자 회사 귀속)
    register: (data) => {
      return chinaInapi.post('/wechat-gzh-accounts', data);
    },

    // 부분 갱신 — 비밀값 빈 문자열은 서버가 "기존값 유지"로 해석
    update: (gzhName, data) => {
      return chinaInapi.put(`/wechat-gzh-accounts/${gzhName}`, data);
    },

    // 연결 테스트 — { ok, errcode?, errmsg?, friendlyMessage? } (실패도 200 진단)
    testConnection: (gzhName) => {
      return chinaInapi.post(`/wechat-gzh-accounts/${gzhName}/test-connection`);
    },

    // 저장된 비밀값 원문 조회 — { appSecret, token, encodingAesKey } (미저장 필드는 '')
    // 편집 모달 프리필용(a-input-password 눈동자로 확인). 소유권 검증은 서버(update와 동일 규칙).
    getSecrets: (gzhName) => {
      return chinaInapi.get(`/wechat-gzh-accounts/${gzhName}/secrets`);
    }
  },

  // 关键词回复(키워드 자동응답) — dentalmax(+미래 테넌트) 전용 china-inapi 신규 파티션 스토어 API
  // SPEC-CHINA-GZH-KEYWORD-TENANT-001 M4. (구 leg 경로 keywordReply/$axios inapi 는 호출부 0건이라 CLEANUP 2026-07-22에서 제거됨.)
  // 소유권 = JWT sub → company_gzh_mappings(REUSE) → gzhName. 모든 CRUD는 ?name=<gzhName> 쿼리로 소유 스코프를 지정한다.
  keywordTenant: {
    keywords: {
      // 키워드 목록 조회 (소유 gzhName 스코프)
      getList: (name, { page = 1, limit = 10, isActive } = {}) => {
        const params = { name, page, limit };
        if (isActive !== undefined) params.isActive = isActive;
        return chinaInapi.get('/cn/wechat/gzh/keywords', { params });
      },

      // 키워드 생성
      create: (name, data) => {
        return chinaInapi.post('/cn/wechat/gzh/keywords', data, { params: { name } });
      },

      // 키워드 수정
      update: (name, id, data) => {
        return chinaInapi.put(`/cn/wechat/gzh/keywords/${id}`, data, { params: { name } });
      },

      // 키워드 삭제
      delete: (name, id) => {
        return chinaInapi.delete(`/cn/wechat/gzh/keywords/${id}`, { params: { name } });
      },

      // 키워드 상태 변경
      toggleStatus: (name, id, isActive) => {
        return chinaInapi.put(`/cn/wechat/gzh/keywords/${id}/status`, { isActive }, { params: { name } });
      }
    },

    // 응답 관련
    responses: {
      // 키워드별 응답 목록 조회
      getByKeywordId: (name, keywordId) => {
        return chinaInapi.get(`/cn/wechat/gzh/keywords/${keywordId}/responses`, { params: { name } });
      },

      // 응답 생성
      create: (name, keywordId, data) => {
        return chinaInapi.post(`/cn/wechat/gzh/keywords/${keywordId}/responses`, data, { params: { name } });
      },

      // 응답 수정
      update: (name, id, data) => {
        return chinaInapi.put(`/cn/wechat/gzh/keyword-responses/${id}`, data, { params: { name } });
      },

      // 응답 삭제
      delete: (name, id) => {
        return chinaInapi.delete(`/cn/wechat/gzh/keyword-responses/${id}`, { params: { name } });
      }
    }
  },
});
